import type { BrandScope } from "src/utils/brand-scope";

/** Why a picker row has nothing to pick, or undefined when it has options. */
export function emptyOptionsTooltip(
  noun: string,
  count: number,
  brandScope: BrandScope,
): string | undefined {
  if (count > 0) {
    return undefined;
  }
  if (brandScope === null) {
    return `No ${noun} yet`;
  }
  // An empty scope offers only the options for every brand, so brand-specific ones may exist.
  if (brandScope.length === 0) {
    return `No ${noun} available`;
  }
  return `No ${noun} for ${brandScope.length === 1 ? "this brand" : "these brands"}`;
}
